export function generateHighlightInput(label: string) {
  return `<highlight-input data-mention-atom-id="${label}" data-mention-atom-name="${label}">${label}</highlight-input>`;
}
